import { HomeFeaturedCardContext } from '@app/domains/home/components/HomeFeaturedCard';
import NovelResponsiveCoverImage from '@app/domains/novel/components/NovelResponsiveCoverImage';
import NovelReviewScore from '@app/domains/novel/components/NovelReviewScore';
import { convertNovelStatusToStr } from '@app/domains/novel/utils';
import { getOneofValue } from '@app/libs/grpc';
import { Paragraph, useHtmlToReact } from '@app/utils/html';
import clsx from 'clsx';
import { useContext } from 'react';

export default function ContentLayer() {
    const { cardType, coverImageUrl, coverBlurHash, title, rating, status, synopsis, isWtu, series } =
        useContext(HomeFeaturedCardContext);
    const refinedSynopsis = useHtmlToReact(synopsis ?? '', {
        removeTags: ['hr', 'img', 'a'],
        transform: {
            p: Paragraph,
        },
    });
    return (
        <>
            <div
                className={clsx(
                    'relative mb-11 h-163 w-112 flex-shrink-0 overflow-hidden rounded-tr-6 rounded-br-6 md:mb-0 md:h-176',
                    {
                        'md:mr-32 md:w-120': cardType === 'default',
                        'md:mr-0 md:w-0': cardType === 'image',
                    }
                )}
            >
                {cardType === 'default' && (
                    <NovelResponsiveCoverImage
                        novel={getOneofValue(series?.item, 'novel')}
                        imgUrl={coverImageUrl}
                        imgBlurHash={coverBlurHash}
                        srcWidth={120}
                        srcHeight={176}
                    >
                        {isWtu && (
                            <NovelResponsiveCoverImage.WtuBadge
                                classes={{
                                    root: 'bottom-4 right-4',
                                    box: 'h-24 w-24',
                                    icon: 'h-16 w-16',
                                }}
                            />
                        )}
                    </NovelResponsiveCoverImage>
                )}
            </div>
            <div className="flex h-108 w-full flex-col justify-center text-white md:mt-0 md:h-auto md:max-w-[720px] md:justify-start">
                <p className="font-set-b20 mb-4 line-clamp-2 md:font-set-b28 md:mb-6">{title}</p>
                <div className="mb-4 flex flex-row items-center md:mb-6 md:flex-col md:items-start">
                    {rating && (
                        <span className="font-set-sb16 md:font-set-b20 md:mb-6">
                            <NovelReviewScore
                                reviewRating={rating}
                                classes={{
                                    goodIcon: 'w-16 h-16 md:w-20 md:h-20',
                                    score: 'ml-3 md:ml-4',
                                }}
                            >
                                <NovelReviewScore.MedalIcon className="h-16 w-16 md:h-18 md:w-18" />
                            </NovelReviewScore>
                        </span>
                    )}
                    <span className="font-set-m13 text-white md:font-set-m18">{convertNovelStatusToStr(status)}</span>
                </div>
                <p className="font-set-r13 text-white line-clamp-2 md:font-set-r16 md:line-clamp-3">
                    {refinedSynopsis}
                </p>
            </div>
        </>
    );
}
